import { BoxDetailTimeProps, BoxTimeItem } from '@/box/interface'
import {
  getOptions,
  ntpServerItems,
  sysTimezoneItems
} from '@/shared/SelectData'
import { getFormatMessage } from '@/utils/utils'
import { Button, Col, Form, Input, Row, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { Title } from '../shared/Title'
import { formItemLayout } from '../shared/Shared'

export const BoxDetailTime: React.FC<BoxDetailTimeProps> = (
  props: BoxDetailTimeProps
) => {
  const { title, formResult, editItem, colSpan, disabled, onSave } = props
  const [timeForm] = Form.useForm<BoxTimeItem>()
  const [ntpType, setNtpType] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const formatMessage = getFormatMessage()

  const defaultColSpan = 12

  const handleNtpTypeChange = (value: string) => {
    setNtpType(value)
    timeForm.setFieldsValue({
      ntpserverType: value,
      ntpserver: value
    } as any)
  }

  const handleTimeSave = async () => {
    if (!onSave) return
    try {
      const value = await timeForm.validateFields()
      setLoading(true)
      await onSave(value)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (editItem) {
      const item = ntpServerItems.find((x) => x.value == editItem.ntpserver)
      const type = item ? item.value : ''
      setNtpType(type)
      editItem['ntpserverType'] = type
      timeForm.setFieldsValue(editItem)
    }
  }, [editItem])

  useEffect(() => {
    if (formResult) {
      handleTimeSave()
    }
  }, [formResult])

  return (
    <Form {...formItemLayout} form={timeForm} labelAlign='right'>
      {title && (
        <Title
          level={4}
          extra={
            <Button
              type='primary'
              loading={loading}
              disabled={disabled}
              onClick={handleTimeSave}
            >
              {formatMessage({ id: 'app.box.detail.edit.save' })}
            </Button>
          }
        >
          {formatMessage({ id: 'app.box.detail.edit.time' })}
        </Title>
      )}

      <Row>
        <Col span={colSpan || defaultColSpan}>
          <Form.Item
            name='ntpserverType'
            label={formatMessage({ id: 'app.box.detail.edit.ntpserverType' })}
          >
            <Select
              onChange={handleNtpTypeChange}
              disabled={disabled}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {getOptions(ntpServerItems)}
            </Select>
          </Form.Item>
        </Col>
        <Col span={colSpan || defaultColSpan}>
          <Form.Item
            name='ntpserver'
            label={formatMessage({ id: 'app.box.detail.edit.ntpserver' })}
            rules={[
              {
                required: true,
                message: formatMessage({
                  id: 'app.box.detail.edit.ntpserver.message'
                })
              }
            ]}
          >
            <Input readOnly={ntpType != ''} disabled={disabled} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={colSpan || defaultColSpan}>
          <Form.Item
            name='timezone'
            label={formatMessage({ id: 'app.box.detail.edit.timezone' })}
          >
            <Select
              disabled={disabled}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {getOptions(sysTimezoneItems)}
            </Select>
          </Form.Item>
        </Col>
        <Col span={colSpan || defaultColSpan}>
          {/* <Form.Item
            name='dateTime'
            label={formatMessage({ id: 'app.box.detail.edit.dateTime' })}
          >
            <DatePicker showTime disabled={disabled} />
          </Form.Item> */}
        </Col>
      </Row>
    </Form>
  )
}
